import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import useIsBillingInformationAvailable from "../CustomHooks/useIsBillingInformationAvailable";

const SeeDentistTabs = () => {
  const location = useLocation();
  const isOnDemandCaptureCreditOrDebitCardEnabled = useSelector((state) => {
    if (state.userData.isOnDemandCaptureCreditOrDebitCardEnabled) {
      return state.userData.isOnDemandCaptureCreditOrDebitCardEnabled;
    } else if (
      location.state?.userData?.isOnDemandCaptureCreditOrDebitCardEnabled
    ) {
      return location.state?.userData
        ?.isOnDemandCaptureCreditOrDebitCardEnabled;
    }
    return false;
  });

  const isPharmacySelectionEnabled = useSelector((state) => {
    if (state.userData.isPharmacySelectionEnabled) {
      return state.userData.isPharmacySelectionEnabled;
    } else if (location.state?.userData?.isPharmacySelectionEnabled) {
      return location.state?.userData?.isPharmacySelectionEnabled;
    }
    return false;
  });

  const isBillingInformationAvailable = useIsBillingInformationAvailable(
    isOnDemandCaptureCreditOrDebitCardEnabled
  );

  return (
    <>
      <ul
        className="nav d-flex flex-wrap justify-content-between mb-5 position-relative"
        id="step-tab"
        role="presentation"
      >
        <li className="nav-item" role="presentation">
          <Link
            to="/see-dentist-options"
            className="complete fs-3 p-0 d-flex flex-wrap justify-content-center align-items-center align-content-center position-relative rounded-pill"
            id="see-call-options"
            type="button"
          >
            <span className="num lh-1">1</span>
            <span className="value fs-6 text-muted lh-1 p-0 mt-2 position-absolute top-100 start-50 translate-middle-x">
              Call <br />
              Options
            </span>
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to=""
            className="complete fs-3 p-0 d-flex flex-wrap justify-content-center align-items-center align-content-center position-relative rounded-pill"
            id="see-dentist-tab"
            data-bs-toggle="pill"
            data-bs-target="#see-dentist"
            type="button"
          >
            <span className="num lh-1">2</span>
            <span className="value fs-6 text-muted lh-1 p-0 mt-2 position-absolute top-100 start-50 translate-middle-x">
              Visit <br />
              Details
            </span>
          </Link>
        </li>
        {isPharmacySelectionEnabled ? (
          <li className="nav-item" role="presentation">
            <Link
              to=""
              className={
                "fs-3 p-0 text-decoration-none d-flex flex-wrap justify-content-center align-items-center align-content-center position-relative rounded-pill " +
                (location.pathname === "/see-dentist-pharmacy-selection" ||
                location.pathname === "/see-dentist-review"
                  ? "complete"
                  : " ")
              }
              id="see-dentist-pharmacy-selection-tab"
              type="button"
            >
              <span className="num lh-1">3</span>
              <span className="value fs-6 text-muted lh-1 p-0 mt-2 position-absolute top-100 start-50 translate-middle-x">
                Select <br />
                Pharmacy
              </span>
            </Link>
          </li>
        ) : (
          <></>
        )}
        <li className="nav-item" role="presentation">
          <Link
            to=""
            className={
              "fs-3 p-0 text-decoration-none d-flex flex-wrap justify-content-center align-items-center align-content-center position-relative rounded-pill " +
              (location.pathname === "/see-dentist-review" && "complete")
            }
            id="review-submit-tab"
            type="button"
          >
            <span className="num lh-1">
              {isPharmacySelectionEnabled ? 4 : 3}
            </span>
            <span className="value fs-6 text-muted lh-1 p-0 mt-2 position-absolute top-100 start-50 translate-middle-x">
              Review <br />
              and Submit
            </span>
          </Link>
        </li>
        {isBillingInformationAvailable ? (
          <li className="nav-item" role="presentation">
            <Link
              to=""
              className={
                "fs-3 p-0 d-flex text-decoration-none flex-wrap justify-content-center align-items-center align-content-center position-relative rounded-pill"
              }
              type="button"
            >
              <span className="num lh-1">
                {isPharmacySelectionEnabled ? 5 : 4}
              </span>
              <span className="value fs-6 text-muted lh-1 p-0 mt-2 position-absolute top-100 start-50 translate-middle-x">
                Billing <br />
                Information
              </span>
            </Link>
          </li>
        ) : (
          <></>
        )}
      </ul>
    </>
  );
};

export default SeeDentistTabs;
